import { PrinterOutlined, SaveOutlined, SearchOutlined } from '@ant-design/icons'
import { Tag, Form as AntForm, Menu, Dropdown } from 'antd'
import axios from 'axios'
import { Button, DeleteButton, Form, Modal, Table, TableCard, Input, Drawer, Export } from 'components'
import React, { useEffect, useState } from 'react'
import { FaPen, FaPlus, FaDownload, FaFilter } from 'react-icons/fa6'
import { MdDelete, MdEdit } from "react-icons/md";
import { FiMoreHorizontal} from "react-icons/fi";
import { Link } from 'react-router-dom'
import searchFields from './searchFields';
import dayjs from 'dayjs'
import { CgScrollH } from 'react-icons/cg'
import ExcelRender from 'modules/components/ExcelRender'

const type = [
    {label:'Ажлахгүй', value: 'Ажлахгүй'},
    {label:'Бүтэн', value: 'Бүтэн'}, 
    {label: 'Хагас', value: 'Хагас'}, 
  ]

function Category() {
  const [ data, setData ] = useState([])
  const [ editData, setEditData ] = useState(null)
  const [ loading, setLoading ] = useState(false)
  const [ actionLoading, setActionLoading ] = useState(false)
  const [ showModal, setShowModal ] = useState(false)
  const [ filterOpen, setFilterOpen ] = useState(false);
  const [ currentPage, setCurrentPage ] = useState(0)
  const [ form ] = Form.useForm()
  const [ header, setHeader ] = useState([]);
  const [ cols, setCols ] = useState([]);
  const [ openModalFileEdit, setOpenModalFileEdit ] = useState(false);
  const [ sector, setSector ] = useState([])
  const [ filterForm ] = Form.useForm();
  const status = [
    {label: <Tag color='error'>Дууссан</Tag>, value: 0},
    {label: <Tag color='processing'>Хэвийн</Tag>, value: 1}, 
    {label: <Tag color='success'>Сунгасан</Tag>, value: 2}, 
  ]

  useEffect(() => {
    getData()
  },[])

  const getData = () => {
    setLoading(true)
    axios({
      method: 'get',
      url:'categories'
    }).then((res) => {
      console.log(res.data);
        setData(res.data)
    }).catch((err) => {
    }).finally(() => setLoading(false))
  }

  const columns = [
    {
      title: '№',
      dataIndex: 'No',
      key: 'No',
      width: 50,
      align: 'center',
      cellRender: (e) => (
        <span>{e.rowIndex + currentPage+1}</span>
      )
    },
    {
      title: 'Нэр',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: "",
      dataIndex: "action",
      key: "action",
      width: 90,
      cellRender: ({ value, data }) => {
        // Dropdown menu items
        const menu = (
          <Menu>
            <Menu.Item key="1" icon={<MdEdit />} onClick={() => handleEditButton(data)}>
              Edit
            </Menu.Item>
            <Menu.Item key="2" icon={<MdDelete/>} danger onClick={() => handleDelete(data)}>
              Delete
            </Menu.Item>
          </Menu>
        );
  
        return (
          <div className="action-cell flex items-center gap-2 " >
            <Dropdown overlay={menu} trigger={['click']}>
              <Button
                type="ghost"
                size="sm"
                icon={<FiMoreHorizontal style={{fontSize : '8px', width: "16px"}}/>}
              />
            </Dropdown>
          </div>
        );
      },
    }
  ]

  const fields = [
    {
      label: 'Нэр',
      name: 'name',
      rules: [{required: true, message: 'Нэр оруулна уу'}],
      className: 'col-span-12 mb-1',
      inputProps: {
      }
    },
  ]
  const handleSubmit = (values) => {
    setActionLoading(true)
    if(editData){
      axios({
        method: 'put',
        url: `/category`,
        data: {
          ...values,
          id: editData.id
        }
      }).then((res) => {
        getData()
        handleCancel()
      })
      .catch((err) => {})
      .finally(() => {
        setActionLoading(false)
      })
    }else{
        axios({
            method: 'post',
            url: `/category`,
            data: { ...values },
          })
            .then((res) => {
              getData();
              handleCancel();
            })
            .catch((error) => {
              console.error('Error:', error);
            })
            .catch((err) => {})
            .finally(() => {
              setActionLoading(false);
            });          
    }
  }


  const handleAddButton = (data) => {
    setEditData(null)
    setShowModal(true)
  }

  const handleEditButton = (data) => {
    setEditData(data)
    setShowModal(true)
  }

  const handleDelete = (data) => {
    setActionLoading(true)
    axios({
      method: 'delete',
      url: `/category/${data.id}`,
    })
    .catch((err) => {})
    .then((res) => {
      getData()
      handleCancel()
    }).finally(() => {
      setActionLoading(false)
    })
  }
  const handleCloseModal = () => {
    setShowModal(false)
  }

  const handleCancel = () => {
    setShowModal(false)
    if(editData){
      setEditData(null)
    }else{
      form.resetFields()
    }
  }

  const handleFilterSubmit = (values) => {
    setLoading(true);
    axios({
      method: 'get',
      url: `/category_search`,
      params: values
    }).then((res) => {
      setData(res.data);
      setFilterOpen(false);
    }).catch((err) => {
    }).finally(() => setLoading(false))
  };
   
  const handleOpenFile = () => {
    setOpenModalFileEdit(true);
  };

  const handleCloseFileModal = () => {
    setOpenModalFileEdit(false);
  };
  const handleOpenModalFileEdit = () => {
    setOpenModalFileEdit(true);
  };

  const handleOpenCloseModalFileEdit = () => {
    setOpenModalFileEdit(false);
  };

  const handleFileSubmit = async (values, method) => {
    let tmp = [];
  
    cols.forEach((item, i) => {
      if (i !== 0) {
        let nameIndex = header.indexOf('name');
        let name = item[nameIndex];
        
    
        if (name && name.trim() !== "") {
          tmp.push({ name });
        }
      }
    });
  
    try {
      setLoading(true);
  
      let url = '/category';
      let requestMethod = method === 'post' ? 'post' : 'put';

      await axios({
        method: requestMethod,
        url: url,
        data: tmp,
      });
  
      getData(); 
      method === 'post' ? handleCloseFileModal() : handleOpenCloseModalFileEdit();
    } catch (err) {
      console.error('Алдаа гарлаа:', err);
    } finally {
      setLoading(false); 
    }
  };
  
  return (
    <TableCard
      header={
        <div className='flex flex-col'>
          <div className='w-full flex justify-between items-center gap-4'>
          <h1 className='text-2xl font-medium'>Ангилалын жагсаалт</h1>
            <div className='flex items-center gap-2'>
              <Button icon={<FaFilter/>} onClick={() => setFilterOpen(true)}>Шүүлтүүр</Button>
              <Export
                fileData={data} 
                fileName={'Ангилал'} 
              />
              <Button
                  icon={<PrinterOutlined className=''/>}
                  onClick={handleOpenFile}
              >
                Excel оруулах
              </Button>
              <Button type='primary' icon={<FaPlus/>}  onClick={handleAddButton}>Нэмэх</Button>
            </div>          
          </div>
        </div>
      }
    >
      <Table
        dataSource={data}
        columns={columns}
        loading={loading}
      />
      <Modal title={editData ? 'Засах' : 'Шинээр нэмэх'}    open={showModal} onCancel={handleCloseModal}>
        <Form
        
          form={form}
          fields={fields}
          editData={editData}
          onFinish={handleSubmit}
          className={'gap-2'}
        >
          <div className='col-span-12 flex justify-end items-center gap-2 mt-5'>
            <Button type='primary' onClick={() => form.submit()} loading={actionLoading} icon={<SaveOutlined/>}>Хадгалах</Button>
            <Button onClick={handleCancel} disabled={actionLoading}>Цуцлах</Button>
          </div>
        </Form>
      </Modal>
      <Drawer
        open={filterOpen}
        onClose={() => setFilterOpen(false)} 
      >
        <div>
          <h1 className='text-xl text-black-text font-bold'>Шүүх</h1>
          <Form
              form={filterForm}
              fields={searchFields()}
              onFinish={handleFilterSubmit}
              className='gap-4'
            />  
            <Button className='w-full mt-4' size='sm' type="primary" onClick={() => filterForm.submit()}>Хайх</Button>
        </div>
      </Drawer>
      <Modal
          title={<div className="text-lg uppercase">{'Ангилал excel оруулах'}</div>}
          open={openModalFileEdit}
          onCancel={handleOpenCloseModalFileEdit}
          width={1200}
          destroyOnClose
          footer={false}
        >
        <AntForm
          form={form}
          onFinish={(values) => handleFileSubmit(values, 'post')} 
        >
          <AntForm.Item>
            <ExcelRender header={header} setHeader={setHeader} cols={cols} setCols={setCols} />
          </AntForm.Item>

          <AntForm.Item>
            <div className="flex justify-end">
              <Button
                type="primary"
                onClick={() => form.submit()} 
                loading={actionLoading}
                icon={<SaveOutlined />}
              >
                Хадгалах
              </Button>
            </div>
          </AntForm.Item>
        </AntForm>

        </Modal>
    </TableCard>
  )
}

export default Category